module.exports = __webpack_public_path__ + "static/media/icon-search-white.876cc104.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Courses/assets/img/icon-search-white.svg
// module id = 244
// module chunks = 0